import * as React from 'react'

const SvgReadingIcon = (props) => (
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.0003 16.5L9.91695 16.3749C9.33808 15.5066 9.04864 15.0725 8.66624 14.7582C8.32771 14.4799 7.93763 14.2712 7.51833 14.1438C7.0447 14 6.52292 14 5.47935 14H4.33366C3.40024 14 2.93353 14 2.57701 13.8183C2.2634 13.6586 2.00844 13.4036 1.84865 13.09C1.66699 12.7335 1.66699 12.2668 1.66699 11.3333V4.16667C1.66699 3.23325 1.66699 2.76654 1.84865 2.41002C2.00844 2.09641 2.2634 1.84144 2.57701 1.68166C2.93353 1.5 3.40024 1.5 4.33366 1.5H4.66699C6.53383 1.5 7.46725 1.5 8.18029 1.86331C8.8075 2.18289 9.31744 2.69282 9.63701 3.32003C10.0003 4.03307 10.0003 4.96649 10.0003 6.83333M10.0003 16.5V6.83333M10.0003 16.5L10.0837 16.3749C10.6626 15.5066 10.952 15.0725 11.3344 14.7582C11.6729 14.4799 12.063 14.2712 12.4823 14.1438C12.956 14 13.4777 14 14.5213 14H15.667C16.6004 14 17.0671 14 17.4236 13.8183C17.7372 13.6586 17.9922 13.4036 18.152 13.09C18.3337 12.7335 18.3337 12.2668 18.3337 11.3333V4.16667C18.3337 3.23325 18.3337 2.76654 18.152 2.41002C17.9922 2.09641 17.7372 1.84144 17.4236 1.68166C17.0671 1.5 16.6004 1.5 15.667 1.5H15.3337C13.4668 1.5 12.5334 1.5 11.8204 1.86331C11.1932 2.18289 10.6832 2.69282 10.3636 3.32003C10.0003 4.03307 10.0003 4.96649 10.0003 6.83333"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgReadingIcon
